import React from 'react';
import loadingImage from '../../Assests/images/logo/loading.png'; 

const Loadericon = () => {
  return (
    <div id="loading" className='bg-none position-static p-3'>
    <div id="loading-center" className='flex flex-column gap-3'>
      <div className="loader-container">
        <div className="wrap-loader">
          <div className="loader"></div>
          <div className="icon">
            <img src={loadingImage} 
            alt="CoOwnSpace Loading..." 
            loading="lazy"/>
          </div>
        </div>
      </div>
      <h3 className='text-center'>Loading Property Data...</h3>

    </div>
  </div>
  );
};

export default Loadericon;
